import { createApp } from 'vue';
import Registration from '@/views/user/Registration.vue';
import { createI18n } from 'vue-i18n/dist/vue-i18n.cjs';
import { createPinia } from 'pinia';
import { VTooltip } from 'floating-vue';
import { CkeditorPlugin } from '@ckeditor/ckeditor5-vue';
import { installViplogeVueQuery } from './vue/plugins/queryClient';
import '@/shared/composables/useTheme';

function loadLocaleMessages() {
  return { nl: window.viploge.lng };
}

const i18n = createI18n({
  legacy: false,
  warnHtmlInMessage: 'off',
  locale: 'nl',
  fallbackLocale: 'nl',
  messages: loadLocaleMessages(),
});

const currentPlatform = JSON.parse(
  document.getElementById('registerApp').dataset.currentPlatform
);

const registration = createApp(Registration, {
  platform: currentPlatform,
});

registration.config.globalProperties.$platform = currentPlatform;

registration.directive('tooltip', VTooltip);

registration.use(i18n);
registration.use(createPinia());
installViplogeVueQuery(registration);
registration.use(CkeditorPlugin);
registration.mount('#registerApp');
